import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getTopDealer } from "http/dashboard";
import NoDataChart from "pages/Dashboards/NoDataChart";
import { formatNumberWithCommas } from "common/utility";

const Top5Dealers = ({ startDate, endDate }) => {
  const [customersData, setCustomersData] = useState([])
  const [showStatus, setShowStatus] = useState(true)
  useEffect(() => {
    getTopDealer()
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi?.data?.length>0) {
          setCustomersData(responseFromApi.data)
        } else {
          setCustomersData(responseFromApi.data)
          setShowStatus(false)
        }
      })
      .catch(error => { })
  }, [])

  useEffect(() => {
    if(startDate && endDate){
      getTopDealer({startDate,endDate})
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length>0) {
            setCustomersData(responseFromApi.data)
            setShowStatus(true)
          } else {
            setCustomersData(responseFromApi.data)
            setShowStatus(false)
          }
        })
        .catch(error => { })
    }
  }, [startDate, endDate])

  const currencyShotern = amount => {
    if (amount && !isNaN(amount) && amount != undefined) {
      const formatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        notation: "compact",
        compactDisplay: "long",
      })
      return formatter.format(amount)
    } else return "0.00"
  }

  const options = {
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: "rounded",
        barHeight: "65%",
        columnWidth: "50%",
        borderRadius: 4,
        dataLabels: {
          position: "center",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return currencyShotern(val);
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "#34c38f";
          case 1:
            return "#3f9ae5";
          case 2:
            return "#f46a6a";
          case 3:
            return "#f1b44c";
          case 4:
            return "#00c5dc";
          default:
            return "#0174BE";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Total Orders",
      },
      labels: {
        formatter: val => {
          return currencyShotern(val)
        },
      },
      style: {
        fontSize: "16.5px",
        color: "#333",
        background: "transparent",
        maxWidth: 300,
        overflow: "ellipsis",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      categories: customersData?.map(
        (customer) => customer.dealerName
      ),
    },
    yaxis: {
      title: {
        text: "Dealer",
      }
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatNumberWithCommas(val) + " Orders";
        },
      },
    },
    toolbar: {
      show: false
    }
  };

  const series = [
    {
      name: "",
      data: customersData?.map((customer) => parseInt(customer.count)),
    },
  ];

  return (
    <Card className="h-100">
      {showStatus ? <CardBody>
        <h4 className="card-title mb-2">Top 5 Dealers</h4>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          className="mb-2"
        >
        </div>
        <div style={{ maxWidth: "100%" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={306}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No data for the top 5 dealers is available at the moment" />
      }
    </Card>
  );
};

export default Top5Dealers;
